import styled from 'styled-components';

export const StyledWrapperButtons = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
`;
